import NpsByDayOfWeekBarChart from './NpsByDayOfWeekBarChart';
export default NpsByDayOfWeekBarChart;



// WEBPACK FOOTER //
// ./src/components/NpsByDayOfWeekBarChart/index.js